import React from "react";
import { Link as RRLink } from "react-router-dom";
import cx from "classnames";

export default function Link({ analyticsClass, className, ...props }) {
    return <RRLink data-button={analyticsClass} className={cx("ts-link", className)} to="#" {...props} />;
}
